<template>
    <div class="server-errors single-page">
        <div class="container-xxl">
            <div class="content p-3 d-flex justify-content-center align-items-center flex-column">
                <img src="/assets/img/error/not-found.png" alt="">
                <h1>SAYFA BULUNAMADI! SORUNU ÇÖZMEYE ÇALIŞIYORUZ.</h1>
                <a :href="Links.Url(Links.Dashboard)" class="btn btn-primary btn-lg p-2">Anasayfa</a>
            </div>
        </div>
    </div>
    <!--<div class="logo">
        <img />
    </div>
    <div class="card">
        <div class="card-header">
            <div class="title">
                <span>SAYFA BULUNAMADI</span>
            </div>
        </div>
        <div class="card-body">
            <div class="mb-3 text-center">
                <i class="fa fa-warning text-warning"></i>
                <p>Üzgünüz, istediğiniz sayfa bulunamadı.</p>
            </div>
        </div>
        <div class="card-footer">
            <router-link class="btn btn-primary" :to="Links.Url(Links.Dashboard)">
                <i class="fa fa-house"></i>
                <span>Anasayfaya Git</span>
            </router-link>
            <button class="btn btn-secondary" @click="$router.back()">
                <i class="fa fa-rotate-left"></i>
                <span>Geri Dön</span>
            </button>
        </div>
    </div>-->
</template>
<script>
export default {
  name: "PageNotFound",
};
</script>
